<template>
    <div class="content-box">
        <Title/>
        <div class="title-right">
      <el-link href="https://www.100ec.cn/zt/wswjsxfpgyl/" target='_blank'>
        <img src="https://www.100ec.cn/Public/home/images/dd.gif"
      /></el-link>
      
    </div>
        <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal">
            <el-menu-item
            :index="String(index + 1)"
            v-for="(i, index) of dataNav"
            :key="index"
            @click="handleSelect(index)">
            {{i.label}}</el-menu-item>
        </el-menu>

        <div class="mobile-select">
            <el-select
            v-model="name"
            @change="handleSelect2">
                <el-option
                v-for="item in dataNav"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </div>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "broadCast",
    data() {
        return {
            activeIndex: '1',
            name: '滚动播报',
            dataNav: [
                {
                    value: '社交',
                    label: '滚动播报'
                },
                {
                    value: '会员电商',
                    label: '会员电商'
                },
                {
                    value: '拼购',
                    label: '拼团/拼购'
                },
                {
                    value: '微商',
                    label: '微商'
                },
                {
                    value: '分销',
                    label: '分销'
                },
                {
                    value: '传销',
                    label: '涉传'
                },
                {
                    value: '社交 裂变',
                    label: '社交裂变'
                },
                {
                    value: '朋友圈',
                    label: '朋友圈'
                },
                {
                    value: '社群',
                    label: '社群'
                },
                {
                    value: '粉丝',
                    label: '粉丝'
                },
                {
                    value: '代理',
                    label: '代理'
                },
            ],
            params: {
                json: 0,
                filter: [
                    "【",
                    "研报",
                    "分析",
                    "（PPT）",
                    "（全文）",
                    "曹磊",
                    "莫岱青",
                    "蒙慧欣",
                    "黄伟"
                ]
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', this.dataNav[0].value)
        this.$store.dispatch('getText')
    },
    methods: {
        handleSelect(index) {
            this.$store.commit('changeKeys', this.dataNav[index].value)
            this.$store.dispatch('getText')
        },
        handleSelect2(value) {
            this.$store.commit('changeKeys', value)
            this.$store.dispatch('getText')
        },
    },
}
</script>
<style scoped>
.title {
  position: relative;
}
.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}
.title-right img {
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }
  .title-right img {
    width: 100%;
    height: 50px;
  }
}
</style>